import React from 'react'

import { RenderFieldValue } from '../renderFieldValue/RenderFieldValue'

interface IProps {
  value: string | number | undefined | null
  keyValue: string
}

export const FieldWithDisabledWarnings = ({ value, keyValue }: IProps) => {
  return <RenderFieldValue value={value} keyValue={keyValue} />
}
